module.exports = __webpack_public_path__ + "static/media/b2g-huggg-logo-dark.eab47654.svg";